<template>
	<div v-if="list && list.length > 0">
		<client-only>
			<div class="swiper-outside-container">
				<swiper
					ref="swiper"
					class="swiper"
					:options="swiperOption"
				>
					<swiper-slide
						v-for="(item, n) in list"
						:ref="`slide${n}`"
						:key="n"
						v-resize="onResize"
					>
						<div class="article-card bgWhite pa-4">
							<div class="img-article">
								<img
									:src="item.featured"
									:alt="item.title"
								>
							</div>
							<b>{{ item.title }}</b>
							<p class="mt-2 mb-1">
								{{ item.description }}
							</p>
						</div>
					</swiper-slide>
					<div
						slot="pagination"
						class="swiper-pagination py-2"
						:class="{'bullets-white': white}"
					/>
				</swiper>
				<v-btn
					absolute
					text
					class="d-lg-none"
					:to="{name: 'blog-tips'}"
				>
					ดูทั้งหมด
					<v-icon
						color="red"
						right
					>
						mdi-arrow-right
					</v-icon>
				</v-btn>
			</div>
		</client-only>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
	components: {
		Swiper,
		SwiperSlide
	},

	props: {
		white: {
			type: Boolean,
			default: false
		},
		count: {
			type: Number,
			default: 4
		},
		list: {
			type: Array,
			default: () => []
		}
	},

	data:() => ({
		// list: [],
		model: null,
		property: null,
		maxHeight: '100%'
	}),

	computed: {
		swiperOption () {
			let items = 1.2
			if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				items = 2
			}
			if (this.$vuetify.breakpoint.sm) {
				items = 3.2
			}
			return {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicBullets: true,
					dynamicMainBullets: 3
				},
				centeredSlides: items !== 2,
				centeredSlidesBounds: true,
				// grabCursor: true,
				slidesPerView: items,
				slidesPerGroup: 1,
				spaceBetween: 15,
			}
		},
	},

	async created() {

	},

	methods: {
		onResize () {
			this.$nextTick(() => {
				this.maxHeight = this.$refs['slide0'][0].$el.clientWidth * 0.75
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.swiper-outside-container {
	position: relative;

	.swiper-container {
		padding-bottom: 72px;
	}
	& > .v-btn--absolute {
		bottom: 15px;
    right: 5px;
    left: unset;
		z-index: 2;
	}

	.swiper-pagination::v-deep {
		@media (max-width: 1263px) {
			left: 7%;
			bottom: 20px !important;
		}
		.swiper-pagination-bullet {
			background-color: #ed1c24;

			&.swiper-pagination-bullet-active::before {
				content: ' ';
				position: absolute;
				top: -2px;
				left: -2px;
				width: 12px;
				height: 12px;
				border: solid 1px #ed1c24;
				border-radius: 50%;
			}
		}

		&.bullets-white {
			.swiper-pagination-bullet {
				background-color: #fff !important;

				&.swiper-pagination-bullet-active::before {
					border-color: #fff !important;
				}
			}
		}
	}

	.article-card {
		.img-article {
			width: 100%;
			height: 200px;
			margin-bottom: 10px;

			img {
				object-fit: cover;
				height: 100%;
				width: 100%;
			}
		}
		b {
			display: block;
			height: 48px;
			overflow: hidden;
		}
		p {
			height: 96px;
			overflow: hidden;
		}
	}

	& ::v-deep .swiper-wrapper {
		height: unset !important;
	}
	& .swiper-slide {
		height: unset !important;
	}
}
</style>
